import { z } from 'zod';
import { isoDateTimeSchema } from './common.js';
/** One full backup file in the backups folder. */
export const backupInfoSchema = z.object({
    name: z.string(),
    size: z.number().int().nonnegative(),
    createdAt: isoDateTimeSchema,
});
export const backupOverviewSchema = z.object({
    backups: z.array(backupInfoSchema),
    /** Only an empty install accepts a restore, so nothing is overwritten. */
    canRestore: z.boolean(),
    /** Hour of the nightly backup, null when it is switched off. */
    nightlyHour: z.number().int().nullable(),
    keep: z.number().int(),
});
export const restoreResultSchema = z.object({
    createdAt: isoDateTimeSchema,
    counts: z.record(z.string(), z.number().int()),
    /** False when the backup came from an install with another APP_SECRET. */
    credentialsKept: z.boolean(),
});
// ------------------------------------------------------- off-site upload
/** FTPS (FTP over TLS) is the default; plain FTP sends password and file unencrypted. */
export const remoteProtocolSchema = z.enum(['ftps', 'ftp']);
/** The off-site target as the settings page shows it; never the password. */
export const remoteBackupSettingsSchema = z.object({
    enabled: z.boolean(),
    protocol: remoteProtocolSchema,
    host: z.string(),
    port: z.number().int(),
    user: z.string(),
    hasPassword: z.boolean(),
    /** Folder on the server; empty means the FTP account's own root. */
    directory: z.string(),
    /** How many backups to keep on the server. */
    keep: z.number().int(),
    lastUploadAt: isoDateTimeSchema.nullable(),
    lastUploadName: z.string().nullable(),
    lastError: z.string().nullable(),
    lastErrorAt: isoDateTimeSchema.nullable(),
});
export const remoteBackupUpdateSchema = z.object({
    enabled: z.boolean().optional(),
    protocol: remoteProtocolSchema.optional(),
    host: z.string().trim().max(255).optional(),
    port: z.number().int().min(1).max(65535).optional(),
    user: z.string().trim().max(120).optional(),
    /** An empty string removes the stored password. */
    password: z.string().max(200).optional(),
    directory: z.string().trim().max(255).optional(),
    keep: z.number().int().min(1).max(365).optional(),
});
export const remoteResultSchema = z.object({
    ok: z.boolean(),
    message: z.string(),
});
/** "Back up now": the new file and, with an off-site target, its upload. */
export const backupRunSchema = z.object({
    backup: backupInfoSchema,
    upload: remoteResultSchema.nullable(),
});
//# sourceMappingURL=backup.js.map